import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Environment } from 'src/environment';

import {
  GetProductsResponse,
  ProductIsInUseResponse,
  UpsertProductResponse,
} from './product-service.model';
import { Product } from '../../shared/models/shared.model';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = `${this.env.API_BASE_URL}/service/poultry-feed-advice/secure`;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  getProductById(id: number): Observable<Product | HttpErrorResponse> {
    return this.http.get<Product>(`${this.baseUrl}/product/${id}`).pipe(
      map((response) => response),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of(<Product>{});
        } else {
          return throwError({ message: error.message });
        }
      }),
    );
  }

  getProducts(): Observable<Product[] | HttpErrorResponse> {
    return this.http
      .get<GetProductsResponse>(`${this.baseUrl}/product/animalType/Broiler`, {})
      .pipe(
        map((response) => response.products),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 404) {
            return of(<Product[]>[]);
          } else {
            return throwError({ message: error.message });
          }
        }),
      );
  }

  checkProductIsInUse(productId: number): Observable<ProductIsInUseResponse | HttpErrorResponse> {
    return this.http
      .get<ProductIsInUseResponse>(`${this.baseUrl}/product/${productId}/check-is-in-use`)
      .pipe(
        map((response) => response),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 404) {
            return of(undefined);
          } else {
            return throwError({ message: error.message });
          }
        }),
      );
  }

  upsertProduct(request: Product): Observable<UpsertProductResponse | HttpErrorResponse> {
    return this.http.post<UpsertProductResponse>(`${this.baseUrl}/product`, request).pipe(
      map((response) => response),
      catchError((error: HttpErrorResponse) => throwError({ message: error.message })),
    );
  }

  deleteProduct(productId: number) {
    return this.http.delete(`${this.baseUrl}/product/${productId}`);
  }
}
